import { useMemo } from 'react';
import settings from '@/settings';
import { getAllCountries } from '@/components/commons/Navbar/ExtendedNavbar/TopNavbar/StoreSelector/constants';
import { useCustomerLocation } from './CustomerLocationContext';
import { pickSuggestedCountry } from './suggestion';

export const useSuggestedCountry = (): string | null => {
  const { country, loading } = useCustomerLocation();

  return useMemo(() => {
    if (loading) {
      return null;
    }

    return pickSuggestedCountry({
      visitorCountry: country,
      storeCountryCode: settings.country_code,
      availableCountryCodes: getAllCountries().map(({ code }) => code),
    });
  }, [country, loading]);
};

export default useSuggestedCountry;
